import { useLang } from "hooks/useLang"
import React from "react"
import ReactMarkdown from "react-markdown"

interface IProps {
    content: string
    title?: string
    className?: string
}

const markdownComponents = () => {
    const { lang } = useLang()

    return {
        ol: ({ ...props }) => (
            <ol {...props} className={`list-decimal max-w-full break-words`} />
        ),
        pre: ({ ...props }) => (
            <pre
                {...props}
                className="mb-2 max-w-full break-words whitespace-pre-wrap"
                style={{ fontFamily: "inherit" }}
            />
        ),
        code: ({ inline, ...props }: any) => (
            <code
                {...props}
                className="break-words whitespace-pre-wrap"
                style={{ fontFamily: "inherit" }}
            />
        ),
        ul: ({ ...props }) => (
            <ul
                {...props}
                className={`list-disc ${
                    lang == "ar" ? "list-inside pr-6" : "pl-6"
                } max-w-full break-words`}
            />
        ),
        li: ({ ...props }) => (
            <li
                {...props}
                className="mb-2 max-w-full break-words whitespace-pre-wrap"
            />
        ),
        h1: ({ ...props }) => (
            <h1
                {...props}
                className="mb-1 mt-5 font-semibold text-xl md:text-2xl first:mt-0 break-words"
            />
        ),
        h2: ({ ...props }) => (
            <h2
                {...props}
                className="mb-1 mt-5 font-semibold text-lg md:text-xl first:mt-0 break-words"
            />
        ),
        h3: ({ ...props }) => (
            <h3
                {...props}
                className="mb-1 mt-5 font-semibold text-md md:text-lg first:mt-0 break-words"
            />
        ),
        h4: ({ ...props }) => (
            <h4
                {...props}
                className="mb-1 mt-5 font-semibold text-sm md:text-md first:mt-0 break-words"
            />
        ),
        p: ({ ...props }) => (
            <p
                {...props}
                className="mb-2 max-w-full break-words whitespace-pre-wrap"
            />
        ),
    }
}

const CustomMarkdown = ({ content, title, className }: IProps) => {
    return (
        <div className={`w-full max-w-full ${className ?? ""}`}>
            {title && <h2 className="text-md font-semibold mb-4">{title}</h2>}
            <ReactMarkdown components={markdownComponents()}>
                {content}
            </ReactMarkdown>
        </div>
    )
}

export default CustomMarkdown
